const waitForImage = (url: string) => {
  return new Promise((resolve) => {
    const img = document.createElement('img');
    let errors = 0;
    img.onload = () => {
      resolve(true);
    };
    img.onerror = () => {
      if (errors > 5) resolve(false);
      errors++;
      setTimeout(() => {
        img.src = url;
      }, 1000);
    };
    img.src = url;
  });
};

export default waitForImage;
